import { useContext, useEffect, useRef, useState } from "react";
import styles from "./style.module.css";
import { WidjetInput } from "../../UI/WidjetInput/WidjetInput";
import { CalendarIcon, MagnifyingGlassIcon, PersonIcon } from "@radix-ui/react-icons";
import classNames from "classnames";
import { WidjetContext } from "../../store/Widjet/widjetContext";
import { format, isValid } from "date-fns";
import { useStore } from "zustand";
import { getModuleIframe } from "../../utils/getModuleIframe";
import useScreenSize from "../../hooks/useScreenSize";
import { postMessageIntoApp } from "../../utils/postMessageIntoApp";
import { useWidjetStore } from "../../store/widjet/useWidjetStore";
import { reviveObject } from "../../utils/reviveObject";
import { FakeWidjetInput } from "../../UI/WidjetInput/FakeWidjetInput";
import { useIsMount } from "../../hooks/useIsMount";

export function Widjet() {
    const store = useRef(useWidjetStore()).current;
    const isFailed = useStore(store, state => state.isFailed);
    const loading = useStore(store, state => state.loading);

    // const mode = useStore(store, state => state.mode);

    useEffect(() => {
        function messageHandler(event) {
            if (event.origin !== process.env.APP_ORIGIN && event.origin !== process.env.WWW_APP_ORIGIN) return;
            if (event.data.isBookingModuleAction) {
                switch (event.data.action) {
                    case "updateStore":
                        store.setState(reviveObject(event.data.data));
                        break;
                    default:
                        return;
                }
            }
        }

        window.addEventListener("message", messageHandler);

        return () => {
            window.removeEventListener("message", messageHandler);
        }
    }, [store]);

    useEffect(() => {
        postMessageIntoApp({ action: "initFromWidjet" })
    }, []);

    // useWidjetStoreController(store, [mode])

    // const setDateFrom = useStore(store, state => state.setDateFrom);
    // const setDateTo = useStore(store, state => state.setDateTo);
    // const setRooms = useStore(store, state => state.setRooms);

    // useEffect(() => {
    //     function popstateHandler(e) {
    //         if (!e.state?.lv_module_open) {
    //             setModuleOpen(false)
    //         }
    //     }

    //     window.addEventListener('popstate', popstateHandler);

    //     return () => {
    //         window.removeEventListener('popstate', popstateHandler);
    //     }
    // }, [moduleOpen, setModuleOpen]);

    // useEffect(() => {
    //     function messageHandler(e) {
    //         if (e.origin === process.env.SITE_ORIGIN) {
    //             if (e.data.dateFrom && e.data.dateTo && e.data.rooms) {
    //                 setDateFrom(new Date(e.data.dateFrom))
    //                 setDateTo(new Date(e.data.dateTo))
    //                 setRooms(e.data.rooms);
    //             }
    //         }
    //     }

    //     window.addEventListener("message", messageHandler);

    //     return () => {
    //         window.removeEventListener("message", messageHandler);
    //     }
    // }, [setDateFrom, setDateTo, setRooms])

    return (
        <WidjetContext.Provider value={store}>
            {loading ? <LoadedWidjet /> : ""}
            {(!loading && !isFailed) ? <FakeWidjet /> : ""}
        </WidjetContext.Provider>
    )
}

// function useWidjetStoreController(store, params) {
//     const isMount = useIsMount();
//     useEffect(() => {
//         if (!isMount) {
//             postMessageIntoApp({ action: "updateStoreFromWidjet", data: JSON.parse(JSON.stringify({ ...store.getState() })) })
//         }
//     }, [store, ...params, isMount])
// }

// Поле "Гости"
function TextFieldRooms({ rooms, onMouseDown, active }) {
    const adultsCount = rooms.reduce((sum, current) => +sum + +current.adults, 0);
    const childsCount = rooms.reduce((sum, current) => +sum + +current.childrens.length, 0);

    return (
        <WidjetInput
            icon={<PersonIcon />}
            label="Гости"
            inputProps={{
                value: `${adultsCount} ${adultsCount > 1 ? "взрослых" : "взрослый"}, ${childsCount} ${childsCount <= 1 && childsCount !== 0 ? "ребенок" : "детей"}`,
                placeholder: "Гости",
                readOnly: true,
                type: "text",
            }}
            onMouseDown={onMouseDown}
            id="booking-rooms-field"
            className={classNames(styles.widjetInputRooms, active ? styles.active : "")}
            isInWidjet={true}
        />
    )
}

// Поле "Дата Выезда"
function TextFieldTo({ value, onMouseDown, active }) {
    return (
        <WidjetInput
            icon={<CalendarIcon />}
            label="Выезд"
            inputProps={{
                value: value,
                placeholder: "Выезд",
                readOnly: true,
                type: "text",
            }}
            onMouseDown={onMouseDown}

            id="booking-to-field"
            className={classNames(styles.widjetInputTo, active ? styles.active : "")}
            isInWidjet={true}
        />
    );
}

// Поле "Дата Заезда"
function TextFieldFrom({ value, onMouseDown, active }) {
    return (
        <WidjetInput
            icon={<CalendarIcon />}
            label="Заезд"
            inputProps={{
                value: value,
                placeholder: "Заезд",
                readOnly: true,
                type: "text",
            }}
            onMouseDown={onMouseDown}

            id="booking-from-field"
            className={classNames(styles.widjetInputFrom, active ? styles.active : "")}
            isInWidjet={true}
        />
    );
}

export function LoadedWidjet({ setIsModuleOpen, setModuleIframe, setIsFailed }) {
    const store = useContext(WidjetContext);

    const dateFrom = useStore(store, state => state.dateFrom);

    const dateTo = useStore(store, state => state.dateTo);

    const rooms = useStore(store, state => state.rooms);

    const timeSettings = useStore(store, state => state.timeSettings);
    const setRooms = useStore(store, state => state.setRooms);

    const roomsLimits = useStore(store, state => state.roomsLimits);


    const monthFrom = new Date(new Date(new Date().setDate(1)).setHours(0, 0, 0, 0));
    const mode = useStore(store, state => state.mode);
    const setMode = useStore(store, state => state.setMode);

    const [calendarOpen, setCalendarOpen] = useState(false);
    const [roomsOpen, setRoomsOpen] = useState(false);

    useEffect(() => {
        function messageHandler(event) {
            if (event.data.isBookingModuleAction && (event.origin === process.env.APP_ORIGIN || event.origin === process.env.WWW_APP_ORIGIN)) {
                switch (event.data.action) {
                    case "closeCalendar":
                        postMessageIntoApp({ action: "closeCalendar" })
                        setCalendarOpen(false);
                        break;
                    case "closeRooms":
                        postMessageIntoApp({ action: "closeRooms" })
                        setRoomsOpen(false);
                        break;
                    default:
                        return;
                }
            }
        }

        window.addEventListener("message", messageHandler);

        return () => {
            window.removeEventListener("message", messageHandler);
        }
    }, [store]);

    // Размер экрана
    const size = useScreenSize();

    // Нажатие на инпут выезда
    function mouseDownToFieldHandler() {
        const dataToUpdate = {};
        dataToUpdate.range = { from: dateFrom, to: dateTo };
        dataToUpdate.numberOfMonths = 2;
        if (mode === "from") {
            postMessageIntoApp({ action: "openCalendar" })
            setCalendarOpen(true);
        } else {
            postMessageIntoApp({ action: !calendarOpen ? "openCalendar" : "closeCalendar" })
            setCalendarOpen(!calendarOpen);
        }
        if (isValid(dateTo)) {
            dataToUpdate.month = (size.width > 768 ? new Date(new Date(new Date(dateTo).setDate(1)).setHours(0, 0, 0, 0)) : monthFrom);
        }
        dataToUpdate.mode = "to"
        postMessageIntoApp({ action: "updateStoreFromWidjet", data: dataToUpdate })
        setMode("to");
    }

    // Нажатие на инпут въезда
    function mouseDownFromFiledHandler() {
        const dataToUpdate = {};
        dataToUpdate.range = { from: dateFrom, to: dateTo };
        dataToUpdate.numberOfMonths = 2;
        postMessageIntoApp({ action: !calendarOpen ? "openCalendar" : "closeCalendar" })
        setCalendarOpen(!calendarOpen);
        if (isValid(dateFrom) && isValid(dateTo)) {
            dataToUpdate.month = (size.width > 768 ? new Date(new Date(new Date(dateFrom).setDate(1)).setHours(0, 0, 0, 0)) : monthFrom);
        }
        dataToUpdate.mode = "from"
        postMessageIntoApp({ action: "updateStoreFromWidjet", data: dataToUpdate })
        setMode("from");
    }


    // Проверяем форму и открываем модуль бронирования 

    function sumbitHandler(e) {
        e.preventDefault();

        function validate() {
            // Проверка на незаполненного ребенка
            if (rooms.find(item => item.childrens.filter(children => children === "").length !== 0)) {
                setRoomsOpen(true);
                postMessageIntoApp({ action: "openRooms" });
                return false;
            }

            return true;
        }

        if (validate()) {
            // setModuleIframe(getModuleIframe(process.env.MODULE_ORIGIN, dateFrom, dateTo, rooms, timeSettings));
            window.history.replaceState({ ...window.history.state, lv_module_open: false }, "", window.location.href);
            window.history.pushState({ ...window.history.state, lv_module_open: true }, "", window.location.href);
            // setIsModuleOpen(true);
            postMessageIntoApp({ action: "openModule" });
        }
    }

    return (
        <div className={styles.wrapper} onClick={() => {
            postMessageIntoApp({ action: "closeCalendar" });
            postMessageIntoApp({ action: "closeRooms" });
            setCalendarOpen(false);
            setRoomsOpen(false);
        }}>
            <form className={styles.form} onSubmit={sumbitHandler} onClick={e => e.stopPropagation()}>
                <TextFieldFrom value={format(dateFrom, "dd.MM.yyyy")} onMouseDown={mouseDownFromFiledHandler} active={calendarOpen && mode === "from"} />
                <TextFieldTo value={format(dateTo, "dd.MM.yyyy")} onMouseDown={mouseDownToFieldHandler} active={calendarOpen && mode === "to"} />
                <div><TextFieldRooms rooms={rooms} onMouseDown={() => {
                    setRoomsOpen(!roomsOpen)
                    postMessageIntoApp({ action: !roomsOpen ? "openRooms" : "closeRooms" });
                }} active={roomsOpen} /></div>
                <button color="dark" className={styles.submit} type="button" onClick={sumbitHandler}><MagnifyingGlassIcon /> Найти</button>
            </form>
        </div>
    );
}

export function FakeWidjet() {
    return (
        <div className={classNames(styles.wrapper, styles.fakeWidjet)}>
            <form className={styles.form} onSubmit={e => e.preventDefault()}>
                <FakeWidjetInput
                    icon={<CalendarIcon />}
                    label="Заезд"
                    className={styles.widjetInputFrom}
                />
                <FakeWidjetInput
                    icon={<CalendarIcon />}
                    label="Выезд"
                    className={styles.widjetInputTo}
                />
                <FakeWidjetInput
                    icon={<PersonIcon />}
                    label="Гости"
                    className={styles.widjetInputRooms}
                />
                <button color="dark" className={styles.submit}><MagnifyingGlassIcon /> Загрузка...  </button>
            </form>
        </div>
    );
}